import { BLOCKS } from '@contentful/rich-text-types';
import { textMd } from '@insify/design-system/typography';
import clsx from 'clsx';
import { graphql } from 'gatsby';
import { Image } from '~components/Image';
import { rawContentToReactComponents } from '~utils/rawContentToReactComponents';
import * as styles from './ContentfulComponentImageTextCard.module.css';

import type { ImageType } from '~components/Image';
import type { RichText } from '~models/contentful';

export type ContentfulComponentImageTextCardContent = {
  image?: ImageType;
  floatingImage?: boolean;
  icon?: ImageType;
  text: RichText;
};

type ContentfulComponentImageTextCardProps = Omit<JSX.IntrinsicElements['article'], 'content'> & {
  content: ContentfulComponentImageTextCardContent;
};

export const ContentfulComponentImageTextCard: React.FC<ContentfulComponentImageTextCardProps> = ({
  content,
  className,
  ...props
}) => {
  const { image, floatingImage, icon, text } = content;

  return (
    <article
      {...props}
      className={clsx(
        styles.card,
        image && styles.withImage,
        floatingImage && styles.withFloatingImage,
        icon && styles.withIcon,
        className,
      )}
    >
      {image && (
        <div className={styles.imageContainer}>
          <Image className={styles.image} image={image} />
        </div>
      )}
      <div className={styles.text}>
        {icon && <Image className={styles.icon} image={icon} />}
        {rawContentToReactComponents(text.raw, {
          renderNode: {
            [BLOCKS.PARAGRAPH]: (_, children) => <p className={clsx(textMd, styles.paragraph)}>{children}</p>,
          },
        })}
      </div>
    </article>
  );
};

export const query = graphql`
  fragment ComponentImageTextCard on ContentfulComponentImageTextCard {
    image {
      ...MixedMedia
    }
    floatingImage
    icon {
      ...MixedMedia
    }
    text {
      raw
    }
  }
`;
